import React, { useEffect, useState } from 'react';
import { TagModel } from 'types/CommonTypes';
import styled from 'styled-components';
import { Row } from 'saladsoft-primitive';

const TagMasterItem = ({
  tag,
  onClick,
}: {
  tag: TagModel;
  onClick: () => void;
}) => {


  return (
    <Wrapper
      onClick={onClick}
    >
      <Row gap={10} alignItems="center" justifyContent="space-between">
        <div>
          <div style={{ fontWeight: 600 }}>{tag?.localizedName?.ko}</div>
        </div>

      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 5px 20px;
  border: 1px solid #efefef;
  border-radius: 10px;

  cursor: pointer;
`;

export default TagMasterItem;
